import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    src: String,
    enabled: { type: Boolean, default: false }
  }

  connect() {
    if (!this.enabledValue || !this.srcValue) return
    if (this.shouldSkipAutoplay()) return

    if (!("IntersectionObserver" in window)) return

    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) this.activate()
    }, { rootMargin: "0px", threshold: 0.45 })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
    if (this.element.pause) this.element.pause()
  }

  activate() {
    if (this.element.getAttribute("src") === this.srcValue) {
      this.playMuted()
      return
    }

    this.element.muted = true
    this.element.defaultMuted = true
    this.element.playsInline = true
    this.element.setAttribute("playsinline", "")
    this.element.setAttribute("muted", "")
    this.element.src = this.srcValue
    this.playMuted()
    this.observer?.disconnect()
  }

  playMuted() {
    const playPromise = this.element.play?.()
    if (playPromise?.catch) playPromise.catch(() => {})
  }

  shouldSkipAutoplay() {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return true
    if (navigator.connection?.saveData) return true
    return false
  }
}
